import React from "react";
import { View, Text, StyleSheet } from "react-native";

const COLOR_MAP = {
  indigo: {
    light: { iconBg: "#eef2ff", iconColor: "#6366f1" },
    dark:  { iconBg: "rgba(99,102,241,0.12)", iconColor: "#818cf8" },
  },
  green: {
    light: { iconBg: "#f0fdf4", iconColor: "#16a34a" },
    dark:  { iconBg: "rgba(22,163,74,0.12)", iconColor: "#4ade80" },
  },
  teal: {
    light: { iconBg: "#ccfbf1", iconColor: "#0d9488" },
    dark:  { iconBg: "rgba(13,148,136,0.12)", iconColor: "#2dd4bf" },
  },
  amber: {
    light: { iconBg: "#fef3c7", iconColor: "#d97706" },
    dark:  { iconBg: "rgba(217,119,6,0.12)", iconColor: "#fbbf24" },
  },
};

export default function TestStatsRow({ stats = [], isDarkMode }) {
  const textPrimary = isDarkMode ? "#f1f5f9" : "#0f172a";
  const textMuted = isDarkMode ? "#64748b" : "#94a3b8";
  const cardBg = isDarkMode ? "#1e293b" : "#ffffff";
  const borderColor = isDarkMode ? "#334155" : "#e2e8f0";

  return (
    <View style={styles.row}>
      {stats.map((stat, index) => {
        const palette = COLOR_MAP[stat.color] || COLOR_MAP.indigo;
        const colors = isDarkMode ? palette.dark : palette.light;

        return (
          <View
            key={index}
            style={[styles.card, { backgroundColor: cardBg, borderColor }]}
          >
            <View style={[styles.iconBox, { backgroundColor: colors.iconBg }]}>
              {stat.icon ? (
                <Text style={{ color: colors.iconColor, fontSize: 20 }}>
                  {stat.icon}
                </Text>
              ) : null}
            </View>
            <View style={styles.info}>
              <Text style={[styles.value, { color: textPrimary }]}>
                {stat.value}
              </Text>
              <Text style={[styles.label, { color: textMuted }]}>
                {stat.label}
              </Text>
            </View>
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    gap: 16,
    marginBottom: 28,
  },
  card: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    padding: 20,
    borderRadius: 16,
    borderWidth: 1,
  },
  iconBox: {
    width: 44,
    height: 44,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  info: {
    flex: 1,
  },
  value: {
    fontSize: 24,
    fontWeight: "800",
    lineHeight: 24,
  },
  label: {
    fontSize: 12,
    fontWeight: "500",
    marginTop: 4,
  },
});
